<template>
  <v-card-actions class="px-6 pt-0 d-flex justify-end dialog-card-actions">
    <v-btn
      class="px-4 d-flex align-center simple-button"
      :class="{
        'pr-2': isShowMode
      }"
      color="primary"
      plain
      :ripple="false"
      @click="close"
    >
      <span class="btn-text">{{ isShowMode ? 'Закрыть' : 'Отмена' }}</span>
    </v-btn>

    <v-btn
      v-if="!isShowMode"
      class="px-4 d-flex align-center"
      color="primary"
      :loading="saveBtnLoading"
      :disabled="isShowMode || isInvalid"
      @click="save"
    >
      <v-icon
        class="uikit-icon pen size-20 white"
        :class="{
          greylighten1: isShowMode || isInvalid,
          send: isSend && !isEdit,
          save: isEdit,
          'size-16': isSend,
          'mb-1px': isEdit
        }"
      />
      <span class="pl-1 btn-text">
        {{ isSend ? 'Отправить' : isEdit ? 'Сохранить' : 'Создать' }}
      </span>
    </v-btn>
  </v-card-actions>
</template>

<script>
export default {
  name: 'DialogCardActions',

  props: {
    isShowMode: Boolean,
    saveBtnLoading: Boolean,
    isEdit: Boolean,
    isSend: Boolean,
    isInvalid: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },
    save() {
      this.$emit('save')
    }
  }
}
</script>

<style scoped>
.mb-1px {
  margin-bottom: 1px !important;
}

.v-card__actions.dialog-card-actions {
  box-shadow: 0px 0px 11px 0px #0000000d;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
</style>
